export default class LLVMIdentifier {
    
}